import { render, staticRenderFns } from "./Sidebar-Left.vue?vue&type=template&id=82106bc6&scoped=true&"
import script from "./Sidebar-Left.vue?vue&type=script&lang=js&"
export * from "./Sidebar-Left.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar-Left.vue?vue&type=style&index=0&id=82106bc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82106bc6",
  null
  
)

export default component.exports